import { requestMethod } from "../../config";
import config from "../../env.config";
import { fetch } from "../../shared/services/api.service";
import { checkApiSuccess } from "../../utils/index";

export const getTeamVariableItemsByCompany = async (payload) => {
    const requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/admin/getTeamVariableItemsByCompany`,
      params: payload,
    };
    const response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    } else return null;
  };


export const addTeamVariableItems = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addTeamVariableItems`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
  return null;
};

export const updateTeamVariableItems = async (payload) => {
    const requestConfig = {
      method: requestMethod.PUT,
      url: `${config.BASE_URL.BASE_API_URL}/admin/updateTeamVariableItems`,
      data: payload,
    };
    const response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    } else return null;
  };

export const deleteTeamVariableItems = async (payload) => {
    const requestConfig = {
      method: requestMethod.DELETE,
      url: `${config.BASE_URL.BASE_API_URL}/admin/deleteTeamVariableItems`,
      data: payload,
    };
    const response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    } else return null;
  };

/**
 * Fetches work information controls and sorting for a team / project.
 * @param {{ companyId: number, projectId: number }} payload
 */
export const getTeamWorkInformation = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/getTeamWorkInformation`,
    params: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
  return null;
};

/**
 * Persists one or more team variable values (immediate save from UI).
 * @param {{ values: Array<{ teamId: number, companyId: number, variableItemId: string, value: * }> }} payload
 */
export const addTeamVariableValues = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/project/addTeamVariableValues`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
  return null;
};